<template>
  <div class="home">
    <section id="preg-1" class="pt-7 pt-md-9">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <!-- Media -->
            <div class="media-decoration media-decoration-1 mb-5 mb-md-0">
              <!-- Image -->
              <img
                class="media-decoration-img img-fluid"
                src="@/assets/iconos/icon-11.png"
                alt="..."
              />
            </div>
          </div>
          <div class="col-md-5 align-self-center mx-auto">
            <!-- Heading -->
            <h2 class="mb-2">{{ datos1.preg }}</h2>

            <!-- Text -->
            <p class="mb-0">{{ datos1.resp }}</p>
          </div>
        </div>
      </div>
    </section>

    <section id="preg-2" class="py-7 py-md-9">
      <div class="container">
        <div class="row">
          <div class="col-md-4 order-md-3">
            <!-- Media -->
            <div class="media-decoration media-decoration-1 mb-5 mb-md-0">
              <!-- Image -->
              <img
                class="media-decoration-img img-fluid"
                src="@/assets/iconos/icon-12.png"
                alt="..."
              />
            </div>
          </div>
          <div class="col-md-5 order-md-1 align-self-center mx-auto">
            <!-- Heading -->
            <h2 class="mb-2">{{ datos2.preg }}</h2>

            <!-- Text -->
            <p class="mb-0">{{ datos2.resp }}</p>
          </div>
        </div>
      </div>
    </section>

    <section id="preg-3" class="pt-7 pt-md-9">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <!-- Media -->
            <div class="media-decoration media-decoration-1 mb-5 mb-md-0">
              <!-- Image -->
              <img
                class="media-decoration-img img-fluid"
                src="@/assets/iconos/icon-8.png"
                alt="..."
              />
            </div>
          </div>
          <div class="col-md-5 align-self-center mx-auto">
            <h2 class="mb-2">{{ datos3.preg }}</h2>

            <!-- Text -->
            <p class="mb-0">{{ datos3.resp }}</p>
            <!-- List -->
            <ul>
              <li
                v-for="(textToPlace, index) in datos3.list"
                v-bind:key="index"
              >
                {{ textToPlace.text }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section id="preg-4" class="py-7 py-md-9">
      <div class="container">
        <div class="row">
          <div class="col-md-4 order-md-3">
            <!-- Media -->
            <div class="media-decoration media-decoration-1 mb-5 mb-md-0">
              <!-- Image -->
              <img
                class="media-decoration-img img-fluid"
                src="@/assets/iconos/icon-7.png"
                alt="..."
              />
            </div>
          </div>
          <div class="col-md-5 order-md-1 align-self-center mx-auto">
            <h2 class="mb-2">{{ datos4.preg }}</h2>

            <!-- Text -->
            <p class="mb-0">{{ datos4.resp }}</p>
          </div>
        </div>
      </div>
    </section>

    <section id="preg-5">
      <div class="jumbotron d-flex">
        <div class="container">
          <div class="row text-center">
            <img
              class="media-decoration-img img-fluid"
              src="@/assets/iconos/icon-6.png"
              alt="..."
              style="margin-left: auto; margin-right: auto"
            />
            <h2 class="mb-2">{{ datos5.title }}</h2>
            <p class="mb-0">{{ datos5.msg }}</p>
          </div>
          <div class="row" style="margin-top: 16px">
            <div class="col-md text-center">
              <p>
                <b>{{ datos5.tipos.hematologicos.title }}</b>
              </p>
              <hr />
              <a
                class="btn btn-gob-lightblue"
                v-on:click="
                  ShowMore(
                    datos5.tipos.hematologicos.title,
                    datos5.tipos.hematologicos.description
                  )
                "
                >Saber más</a
              >
            </div>
            <div class="col-md text-center">
              <p>
                <b>{{ datos5.tipos.tumorales.title }}</b>
              </p>
              <hr />
              <a
                class="btn btn-gob-lightblue"
                v-on:click="
                  ShowMore(
                    datos5.tipos.tumorales.title,
                    datos5.tipos.tumorales.description
                  )
                "
                >Saber más</a
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="preg-6" class="py-7 py-md-9">
      <div class="container">
        <div class="row">
          <div class="col-md-4 order-md-3">
            <!-- Media -->
            <div class="media-decoration media-decoration-1 mb-5 mb-md-0">
              <!-- Image -->
              <img
                class="media-decoration-img img-fluid"
                src="@/assets/iconos/icon-4.png"
                alt="..."
              />
            </div>
          </div>
          <div class="col-md-5 order-md-1 align-self-center mx-auto">
            <h2 class="mb-2">{{ datos6.preg }}</h2>

            <!-- Text -->
            <p class="mb-0">{{ datos6.resp }}</p>
          </div>
        </div>
      </div>
    </section>

    <section id="preg-7" class="jumbotron d-flex align-items-center">
      <div class="container">
        <div class="row">
          <h2 class="text-center">{{ datos7.preg }}</h2>

          <!-- Text -->
          <ul>
            <li v-for="(links, index) in datos7.resp" v-bind:key="index">
              <a v-bind:href="'' + links.url">{{ links.title }}</a>
            </li>
          </ul>

          <ul>
            <p>Bibliografía</p>
            <li
              v-for="(biblio, index) in datos7.bibliografia"
              v-bind:key="index"
            >
              <a v-bind:href="'' + biblio.url">{{ biblio.title }}</a>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section id="middle-contact">
      <div class="container text-center">
        <div class="row">
          <h2>Dudas</h2>
          <img
            class="media-decoration-img"
            src="@/assets/iconos/icon-1.png"
            style="margin-left: auto; margin-right: auto"
          />
        </div>
        <div class="row">
          <a
            @click="$router.push('contact')"
            class="btn btn-gob-gold"
            style="
              width: auto;
              margin-left: auto;
              margin-right: auto;
              margin-top: 32px;
            "
            >Contactanos</a
          >
        </div>
      </div>
    </section>
  </div>
</template>


<style>
#middle-contact {
  min-height: 20vh;
  padding: 36px;
  background-color: #e0e0e0; /* Material Gray 300 */
}

#fuentes {
  margin-top: 36;
}

#preg-7 {
  background-color: #f5f5f5; /* Material Grey 100 */
  padding: 36px;
}

#preg-7 .container ul {
  margin-top: 32px;
  list-style-type: none;
}

#preg-5 {
  padding: 36px;
  margin: 36px;
}

.media-decoration-img {
  max-width: 300px;
}

.home .container .row {
  max-width: 90%;
  margin-left: auto;
  margin-right: auto;
}
</style>


<script>
// Importamos JQuery
const $ = require("jquery");
// Lo declaramos globalmente
window.$ = $;

$(document).ready(function () {
  console.info("pageReady");

  /**
   * Listen to scroll to change header opacity class
   */
  function checkScroll() {
    var startY = $(".navbar").height() * 2; //The point where the navbar changes in px

    if ($(window).scrollTop() > startY) {
      $(".navbar").addClass("scrolled");
    } else {
      $(".navbar").removeClass("scrolled");
    }
  }

  if ($(".navbar").length > 0) {
    $(window).on("scroll load resize", function () {
      checkScroll();
    });
  }
});

// @ is an alias to /src
//import Index from '@/components/Index.vue'

export default {
  name: "Home",
  components: {
    //Index
  },
  methods: {
    ShowAlert(title, message, icon) {
      this.$swal(title, message, icon);
    },

    ShowMore(title, text) {
      // type: 1 Hematologicos, typ:2 Tumorales

      this.$swal({
        title: title,
        html: text,
        icon: "info",
      });
    },
  },
  data() {
    return {
      datos1: {
        preg: "¿Qué es el cáncer infantil?",
        resp: `No es una sola enfermedad, sino que incluye un gran número de enfermedades, con unas características particulares y con un comportamiento absolutamente diferente entre sí.
              Sin embargo, todas estas enfermedades tienen en común que se originan a partir del crecimiento anormal de una sola célula o de un grupo de ellas, que poseen la capacidad de invadir tanto los órganos vecinos como los órganos alejados
              `,
      },
      datos2: {
        preg: "Causas del cáncer infantil",
        resp: `La causa del cáncer no se conocen en su totalidad y se consideran de origen multifactorial, por mutaciones genéticas, estilo de vida y factores o condiciones ambientales que propician el desarrollo. En general no hay una causa específica.`,
      },
      datos3: {
        preg: "Medidas de diagnóstico oportuno",
        resp: `Brindar atención médica oportuna en el primer nivel de atención es una estrategia crucial para la detección temprana del cáncer. El personal de salud debe de conocer los signos y síntomas de alarma sugestivos de malignidad, como lo son:`,
        list: [
          { text: `Pérdida de peso 10% del peso en los últimos 6 meses` },
          { text: `Fiebre sin proceso infeccioso aparente` },
          { text: `Palidez progresiva, fatiga, cansancio o apatía sin causa` },
          { text: `Dolor en huesos y/o articulaciones` },
          {
            text: `Adenopatías con características mayor de 2.5 cm de consistencia dura y no dolorosa`,
          },
          {
            text: `Aumento de volumen en cualquier parte del cuerpo como abdomen o extremidades`,
          },
          { text: `Reflejo blanco en pupila, desviación de uno o ambos ojos` },
          {
            text: `Dolor de cabeza persistente o recurrente de predominio matutino`,
          },
          { text: `Sangrado de encías o nariz` },
        ],
      },
      datos4: {
        preg: "Tratamiento",
        resp: `El objetivo del tratamiento es disminuir la cantidad de células cancerígenas buscando eliminarlas por completo. Para esto se cuenta con cirugía, medicamentos (quimioterapia, terapia dirigida, terapia hormonal, inmunoterapia, etc.) y radiación. 
              El tipo de manejo que se le brinda a un paciente depende del diagnóstico preciso y determinación de la etapa clínica. En ocasiones un paciente puede recibir una o más de estas opciones terapéuticas en conjunto para obtener mejores resultados. 
              Se debe de ofrecer un manejo integral, esto incluye la atención multidisciplinaria para mejorar en medida de lo posible la calidad de vida que puede ser afectada por el mismo cáncer o por el tratamiento empleado. 
              `,
      },
      datos5: {
        title: "Tipos de cáncer",
        msg: "A gran escala podemos dividir los tipos de cáncer infantil en dos grandes grupos:",
        tipos: {
          hematologicos: {
            title: "Hematológicos",
            description: `
            <p style="text-align: left">
              La médula ósea se encuentra en el interior de huesos largos principalmente. Se caracteriza por ser un conjunto de células productoras de sangre, células adiposas y otras células de sostén. Las células productoras de sangre se dividen en linfoides y mieloides, las primeras dan lugar a linfocitos y las mieloides se transforman en glóbulos rojos, otros glóbulos blancos o plaquetas.
              
              <br><br>
              <b>Leucemias</b>
              <br>
              Las leucemias son cánceres que se originan por una producción alterada de células sanguíneas. Si la leucemia tiene un crecimiento acelerado se denomina aguda, en cambio si tiene una progresión más lenta se conoce como crónica; otro aspecto importante para  el diagnóstico es saber de qué tipo de células madres se origina. 
              <br><br>
              La mayoría de las leucemias que se presentan en la población infantil son agudas.
              <br>Los dos tipos principales son:
              <br>
              <ul style="text-align: left">
                <li><b>Leucemia linfoblástica aguda:</b><br>Representa 3 de cada 4 leucemias en niños aproximadamente, es el tipo más frecuente de los hematológicos y de todos los padecimiento oncológicos infantiles.</li>
                <li><b>Leucemia mieloide aguda:</b><br>Es el segundo tipo más común de leucemia en la población infantil.</li>
              </ul>
              </p>
              `,
          },
          tumorales: {
            title: "Tumores solidos",
            description: `
            <p style="text-align: left">
              Un tumor es una masa anormal que se produce a partir de un crecimiento celular acelerado y desorganizado. 
              <br>
              Estos tumores, dependiendo de sus características, pueden ser benignos o malignos, y se pueden desarrollar en diferentes partes del cuerpo con excepción de la médula ósea.
              <br><br>
              Entre los más frecuentes se encuentran: 
              <br>
              <ul style="text-align: left">
                <li>Tumores del Sistema Nervioso Central (SNC)</li>
                <li>Linfomas</li>
                <li>Tumores germinales/gonadales</li>
                <li>Tumores óseos</li>
                <li>Retinoblastoma</li>
                <li>Tumores de tejidos blandos: Rabdomiosarcoma y otros no Rabdomiosarcomas</li>
                <li>Neuroblastoma</li>
                <li>Tumores renales</li>
                <li>Tumores hepáticos</li>
                <li>Entre otros</li>
              </ul>
            </p>
            `,
          },
        },
      },
      datos6: {
        preg: "¿Qué hacer si se sospecha de algún síntoma de cáncer en niños, niñas o adolescentes?",
        resp: "Si se tiene la sospecha de presentar  alguno de los signos y síntomas antes descritos es indispensable acudir a revisión con su médico para que se pueda realizar una valoración completa, y referir a segundo o tercer nivel de atención según sea necesario.",
      },
      datos7: {
        preg: "¿En dónde puedo leer más información oficial?",
        resp: [
          {
            title: "Organización Mundial de la Salud",
            url: "https://www.who.int/es/news-room/fact-sheets/detail/cancer-in-children",
          },
          {
            title: "Organización Panamericana de la Salud",
            url: "https://www.paho.org/es/temas/cancer-ninez-adolescencia",
          },
          {
            title:
              "Centro Nacional para la La Salud de la Infancia y la Adolescencia, Secretaría de Salud, Gobierno de México",
            url: "https://www.gob.mx/salud/censia/acciones-y-programas/programa-cancer-en-la-infancia-y-la-adolescencia",
          },
          {
            title:
              "Instituto Nacional de Salud Pública (INSP) e Instituto Nacional de Cancerología (INCan)",
            url: "https://www.insp.mx/infografias/cancer-ninos.html",
          },
        ],
        bibliografia: [
          {
            title: `OMS. (2021, February 12). El cáncer infantil. El cáncer infantil. Retrieved November 26, 2021`,
            url: "https://www.who.int/es/news-room/fact-sheets/detail/cancer-in-children",
          },
          {
            title: `Datos sobre el cáncer infantil. (s/f). Stjude.org. Recuperado el 27 de noviembre de 2021`,
            url: "https://www.stjude.org/es/cuidado-tratamiento/datos-sobre-el-cancer-infantil.html",
          },
          {
            title: `(S/f). Cancer.org. Recuperado el 27 de noviembre de 2021`,
            url: "https://www.cancer.org/content/dam/CRC/PDF/Public/6041.96.pdf",
          },
          {
            title: `¿Qué es el cáncer? (1980, enero 1). Cancer.gov.`,
            url: "https://www.cancer.gov/espanol/cancer/naturaleza/que-es",
          },
          {
            title: `de Salud, S. (s/f). Signos y síntomas de alerta para sospecha de cáncer en menores de 18 años. Gob.mx. Recuperado el 27 de noviembre de 2021`,
            url: "https://www.gob.mx/salud/acciones-y-programas/signos-y-sintomas-de-alerta-para-sospecha-de-cancer-en-menores-de-18-anos-12232",
          },
          {
            title: `Institute for Health Metrics and Evaluation. Global Burden of Disease: Mexico. 5-14 years, Deaths, 2019. University of Washington. `,
            url: "https://vizhub.healthdata.org/fgh/",
          },
          {
            title: `Muñoz-Aguirre P, Huerta-Gutierrez R, Zamora S, et al. Acute Lymphoblastic Leukaemia Survival in Children Covered by Seguro Popular in Mexico: A National Comprehensive Analysis 2005-2017. Health Syst Reform. 01 01 2021;7(1):e1914897.`,
            url: "",
          },
          {
            title: `Centro Nacional para la Salud de la Infancia y Adolescencia. Comportamiento Epidemiológico del Cáncer en menores de 18 años. México 2008 - 2014. Secretaría de Salud, Gobierno de México.`,
            url: "http://censia.salud.gob.mx/contenidos/descargas/cancer/20160601_Boletin-2014_SEDP12sep16_4.pdf ",
          },
          {
            title: `Acerca de la leucemia en niños. (n.d.). Www.cancer.org. Retrieved November 28, 2021`,
            url: "https://www.cancer.org/es/cancer/leucemia-en-ninos/acerca.html",
          },
        ],
      },
    };
  },
};
</script>
